import { FieldErrors } from 'common/components/core/FieldErrors'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import React, { ComponentProps } from 'react'
import { useGoogleLoginSubmit } from 'src/public-pages/hooks/use-google-login-submit'
import { Button as CommonButton } from 'src/shared/components/button/button'
import type { WebsiteButtonsInterface } from 'src/shared/types/website-settings-types'
export interface PublicPageGoogleAuthButtonProps
  extends Omit<
    ComponentProps<typeof CommonButton>,
    'attrId' | 'loading' | 'onClick'
  > {
  button?: Partial<WebsiteButtonsInterface>
  attrId?: string
}

export const PublicPageGoogleAuthButton: React.FC<
  PublicPageGoogleAuthButtonProps
> = ({ button, text, attrId = '', ...rest }) => {
  const { loading, errors, handleGoogleSignIn } = useGoogleLoginSubmit()
  const host = `${process.env.CLOUDFRONT_PUBLISHER_ASSETS_HOST}/assets/images/public-pages/`
  return (
    <>
      <CommonButton
        attrId={attrId}
        loading={loading}
        onClick={handleGoogleSignIn}
        textColor={'#0F172A'}
        background={'#FFFFFF'}
        border={{
          style: BorderStyleEnum.solid,
          width: 1,
          type: BorderTypeEnum.fullBorder,
          radius: {
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6,
            borderBottomRightRadius: 6,
            borderBottomLeftRadius: 6,
          },

          color: '#D7D8DA',
        }}
        padding={button?.padding}
        textFontFamily={button?.typography?.fontFamily}
        textFontSize={button?.typography?.fontSize}
        textFontStyle={button?.typography?.fontStyle}
        textFontWeight={button?.typography?.fontWeight}
        mobileTextFontFamily={button?.typography?.mobileFontFamily}
        mobileTextFontSize={button?.typography?.mobileFontSize}
        mobileTextFontStyle={button?.typography?.mobileFontStyle}
        mobileTextFontWeight={button?.typography?.mobileFontWeight}
        text={
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <img src={`${host}google.svg`} alt="Google" />
            {text}
          </div>
        }
        {...rest}
      />
      <FieldErrors errors={errors} />
    </>
  )
}
